import { z } from "zod";

const lensingErrorTypeValues = ["LENSING_REQUEST_FAILED", "LENSING_RESPONSE_INVALID"] as const;

const lensingErrorTypeSchema = z.enum(lensingErrorTypeValues);
const LensingErrorType = lensingErrorTypeSchema.enum;
type LensingErrorType = z.infer<typeof lensingErrorTypeSchema>;

type ErrorDetails = {
  sentryDescription: string;
};

export type LensingErrors =
  | {
      errorType: typeof LensingErrorType.LENSING_REQUEST_FAILED;
      data: {
        operationId: string;
        httpStatus?: number;
        axiosErrorCode?: string;
        lensingErrorCode?: string;
        diagnosticCodes: { path: string; code?: string }[];
        attemptCount: number;
        outcomeUnknown: boolean;
      };
    }
  | {
      errorType: typeof LensingErrorType.LENSING_RESPONSE_INVALID;
      data: {
        operationId: string;
        issues: { path: string; code: string }[];
      };
    };

export const lensingErrorDetails = {
  [LensingErrorType.LENSING_REQUEST_FAILED]: {
    sentryDescription: "Lensing request failed.",
  },
  [LensingErrorType.LENSING_RESPONSE_INVALID]: {
    sentryDescription: "Lensing returned a response that did not match the expected schema.",
  },
} as const satisfies Record<LensingErrorType, ErrorDetails>;
